module.exports = __webpack_public_path__ + "img/GreekTechToxotai3_ua.2e1b6728.webp";